<template>
    <div class="wrapper">
        <template>
            <Header />
            <side-bar>
                <sidebar-link to="/dashboard">
                    <md-icon>home</md-icon>
                    <p>{{translate(locale.home)}}</p>
                </sidebar-link>
            </side-bar>

            <div class="main-panel" style="padding-top:68px">

                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>

                <Footer />
            </div>
        </template>

    </div>
</template>

<script>
    import Footer from '../components/Footer.vue'
    import Header from '../components/Header.vue'
    export default {
        components: { Header, Footer },
        created() {
        },
    }
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .1s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
</style>


// WEBPACK FOOTER //
// src/pages/Layout.vue